import { css } from '@/styled-system/css';

export const form = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const subtitle = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  lineHeight: '1.5',
});

export const textareaWrapper = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'xs',
});

export const label = css({
  fontSize: 'sm',
  fontWeight: '600',
  color: 'hpxBlue600',
});

export const textarea = css({
  width: '100%',
  minHeight: '80px',
  padding: '1x',
  fontSize: 'sm',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '4px',
  resize: 'vertical',
  fontFamily: 'inherit',
  _focus: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
    borderColor: 'hpxTeal500',
  },
});

export const radioGroup = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
});

export const radioLabel = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  fontSize: 'sm',
  color: 'hpxBlue500',
  cursor: 'pointer',
});

export const radioInput = css({
  accentColor: '#007a70',
  width: '16px',
  height: '16px',
  cursor: 'pointer',
});

export const errorMessage = css({
  fontSize: 'sm',
  color: 'hpxRed400',
  textAlign: 'center',
});
